import React from 'react';
import {updateObject} from '../Utils';

const ContextGame = React.createContext();

function gameReducer(state, action){
  switch(action.type){
    case "NextGame":
      return updateObject(state, {...action,playing: false,initPlay: false});

    case "UpdateMobile":
      return updateObject(state,action);

    case "SwitchInitPlay":
      return updateObject(state,{initPlay: !state.initPlay});

    case "UpdateLevel":
      return updateObject(state,action);

    default:
      return state;
  }
}

function GameProvider({children, initGame, gameName}){
  const [state, dispatch] = React.useReducer(gameReducer,{
    name:gameName,
    games:initGame.game.games,
    id:0,
    level:3
  });

  return (
    <ContextGame.Provider value={{state, dispatch}}>
      {children}
    </ContextGame.Provider>
  );
}

export {GameProvider,ContextGame};
